import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { HeaderButton } from 'src/app/models/headerbtn.model';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { CurrentUser } from 'src/app/models/user/current-user.model';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {
  SchoolModuleEvent,
  lessondetails,
  lessonnote,
  liveclassschedule,
} from 'src/app/models/module/moduledetails';
import { AdminAction } from 'src/app/models/adminaction.model';
import { param } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UtilService } from 'src/app/services/util.service';
import * as introJs from 'intro.js/intro.js';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';

declare var $: any;

@Component({
  selector: 'app-classdetails',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
})
export class DetailsComponent implements OnInit {
  showlessonfileupload: boolean = false;
  lesson: lessondetails = new lessondetails();
  confirmLessonDelete: boolean = false;
  notehtml: SafeHtml = '';
  prevlesson: any;
  nextlesson: any;
  breadcrumb: BreadCrumb[];
  headerbtn: HeaderButton[];
  //currentuser: any;
  moduleid: number = 0;
  classid: number = 0;
  errorMessage: string;
  fetchingdata: boolean;
  //adminuser: boolean;
  adminActions: AdminAction[] = [];
  classfiles: any;
  liveclassschedules: liveclassschedule[];
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  hasemptytag: boolean = false;
  enableNextLesson: boolean = false;
  classFileName: string;
  introJS = new introJs();
  toursteps: any[] = [];
  isClassCompleted: boolean = false;
  completedText = 'Mark Completed';
  schoolModuleEvent: Array<SchoolModuleEvent> = [];
  displayEvents: Array<SchoolModuleEvent> = [];
  lessonnote: Array<lessonnote> = [];
  currentPage: number;
  
  //eventsFeatureAvailable = false;
  constructor(
    public headerinfo: ComponentheaderService,
    private classmanager: ClassmanagementService,
    private modulemanager: ModulemanagementService,
    public userservice: UseraccessserviceService,
    private router: ActivatedRoute,
    private route: Router,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    public sanitizer: DomSanitizer,
    public util: UtilService,
    public schoolservice: SchoolmanagementService
  ) {
    headerinfo.setHeaderDisplay('Loading Lesson...', [], []);
    console.log('home');
    console.log(this.headerinfo);
    // setTimeout(async () => {
    //   await classmanager.createlog(this.classid).toPromise()
    // }, 120000);
    //this.currentuser = this.userservice.currentUser.id;
    this.toursteps = [
      {
        intro: ' Lesson Note is displayed Here',
        position: 'right',
      },
    ];
    this.introJS.setOptions({
      steps: this.toursteps,
      showProgress: false,
      exitOnOverlayClick: true,
      exitOnEsc: true,
      skipLabel: 'Exit',
    });
  }
  async ngOnInit() {
    //debugger;
    //let schooldetails: any = await this.schoolservice.getSchoolDetails().toPromise();
    this.setLesson();
    this.route.events.subscribe((event) => {
      //this.checkCompleteMark();
    });
    //this.checkCompleteMark();
    $('.modal').on('click', function () {
      $('#deleteLesson').modal('hide');
    });
  }

  tourclicked() {
    let livescheduledesc = '';
    let materialdesc = '';
    let assessmentdesc = '';
    if (this.lesson.adminuser) {
      livescheduledesc =
        'Live lessons are scheduled in this section and scheduled live sessions are displayed';
      materialdesc =
        'Files related to this lesson can be uploaded here. Uploaded files are made available for the course participants. Uploaded files also appear here';
      assessmentdesc =
        'Assessments for this lesson are available here. Button to create new assessment is also displayed';
    } else {
      livescheduledesc =
        'Scheduled live lectures for this lesson are displayed in this section';
      materialdesc =
        'Uploaded files relating to this course appear here for download';
      assessmentdesc = 'Assessments for this lesson are displayed here';
    }
    this.introJS.addSteps([
      {
        element: 'lessonliveschedule',
        intro: livescheduledesc,
        position: 'left',
      },
      {
        element: 'lessonmaterials',
        intro: materialdesc,
        position: 'left',
      },
      {
        element: 'lessonassessments',
        intro: assessmentdesc,
        position: 'left',
      },
    ]);

    //this.introJS.start();
  }
    
  setLesson() {
    this.router.queryParams.subscribe((routeParams) => {
      window.scrollTo(0, 0);
      if (routeParams.classid > 0) {
        this.classid = routeParams.classid;
      }
      if (routeParams.moduleid > 0) {
        this.moduleid = routeParams.moduleid;
      }
      this.getLesson(this.moduleid, this.classid);
    });
  }
  loadNotes(page: number = 1){
    
    if(this.lessonnote[page - 1]?.content){
      this.notehtml = this.sanitizer.bypassSecurityTrustHtml(
        this.lessonnote[page -1].safeContent
      );
      this.hasemptytag = this.lesson.note.safeContent == '<p><br></p>';
    }    
    else{
      this.notehtml = "";
    }
    this.currentPage = page;
  }
  async getLesson(moduleid: number, classid: number) {
    //debugger;
    this.headerinfo.pageLoadingStarted(this);
    this.fetchingdata = true;

    try {
      const data = await this.classmanager.getClassDetails(classid).toPromise();

      this.lesson = data;
      this.lessonnote = data.note;
      this.loadNotes();
      
      if(this.lessonnote.length == 0){
        this.lessonnote[0]=new lessonnote();
        this.lessonnote[0].schoolModuleClassID=classid;     
      }

      if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
        this.lesson.assessments = 0;
      }
      else{
        this.lesson.assessments = data.assessments;
      }

      this.moduleid = this.lesson.moduleid;
      this.isClassCompleted = data.completed;

      if(!await this.util.hasFeature(FeatureGroups.EVENTS)){
        this.schoolModuleEvent = [];
      }
      else{
        this.schoolModuleEvent = await this.modulemanager
          .getUpcomingModuleInvites(this.moduleid,classid);
      }
      //debugger;
      this.fetchingdata = false;
      var displayName = this.lesson.title;
      if (this.lesson.adminuser) {
        this.adminActions = [
          {
            displaytext: 'Edit Notes / Videos',
            route: '/user/lessonnote',
            params: { classid: this.classid },
            classes: ['fas', 'fa-indent'],
          },
          {
            displaytext: 'Edit Lesson',
            route: '/user/editlesson',
            params: { classid: this.classid },
            classes: ['fa', 'fa-edit'],
          },
          {
            displaytext: 'Media Library',
            route: '/user/modulemedialibrary',
            params: { moduleid: this.lesson.moduleid, classid: this.classid },
            classes: ['fas', 'fa-photo-video'],
            disabled: !await this.util.hasFeature(FeatureGroups.MEDIA_LIBRARY),
            featureGroup: FeatureGroups.MEDIA_LIBRARY
          },
          // { displaytext: 'Edit Lesson Description', route: '/user/lessonnote', params: { moduleID: this.moduleid, classid: this.classid } },
          {
            displaytext: 'Delete All Notes / Videos',
            callback: this.popconfirmdeletenote.bind(this),
            classes: ['fas', 'fa-trash'],
          },
          {
            displaytext: 'Delete Lesson',
            callback: this.popconfirmdelete.bind(this),
            classes: ['fas', 'fa-trash'],
          },
          {
            displaytext: 'Manage Assessments',
            route: '/user/assessmentconsole',
            params: { classid: this.classid,batchid: 0 },
            classes: ['fas', 'fa-tasks'],
            disabled: !await this.util.hasFeature(FeatureGroups.ASSESSMENTS),
            featureGroup: FeatureGroups.ASSESSMENTS
          },
          {
            displaytext: 'Manage Events',
            route: '/events/view',
            params: { moduleID: this.lesson.moduleid,classid: this.classid },
            classes: ['fas', 'fa-calendar'],
            disabled: !(await this.util.hasFeature(FeatureGroups.EVENTS)),
            featureGroup: FeatureGroups.EVENTS,
          }
          // { displaytext: 'Lesson Log', route: '/user/lessonnote', params: { moduleID: this.moduleid, classid: this.classid } },
        ];
      } else {
        this.adminActions = [];
      }
      this.headerinfo.setHeaderDisplay(
        this.lesson.title,
        [
          { displaytext: 'School', route: `/user/schoolhome` },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.lesson.moduleid },
          },
          {
            displaytext: 'Lesson',
            route: `/user/lesson`,
            params: { classid: classid },
          },
        ],
        this.adminActions,
        this.toursteps
      );

      this.displayEvents =this.schoolModuleEvent.slice(0, 3);
      const prevLessonPromise = this.classmanager
        .getprevlesson(this.classid, this.moduleid)
        .toPromise();
      const nextLessonPromise = this.classmanager
        .getnextlesson(this.classid, this.moduleid)
        .toPromise();
      const classFilesPromise = this.classmanager
        .getclassfiles(classid)
        .toPromise();
      const liveClassPromise = this.classmanager
        .getLiveClassSchedules(this.classid)
        .toPromise();

      [
        this.prevlesson,
        this.nextlesson,
        this.classfiles,
        this.liveclassschedules,
      ] = await Promise.all([
        prevLessonPromise,
        nextLessonPromise,
        classFilesPromise,
        liveClassPromise,
      ]);

      //console.log(this.classfiles[0]);

      if (this.nextlesson) {
        let currentdate = new Date();
        let lessonPublishedDate = new Date(this.nextlesson.publishdate);
        if (lessonPublishedDate.getTime() < currentdate.getTime()) {
          this.enableNextLesson = true;
        }
      } else {
        this.enableNextLesson = false;
      }

      this.headerinfo.pageLoadingDone(this);
    } catch (error) {
      //debugger;
      this.headerinfo.pageLoadingDone(this);
      // this.errorMessage = "Error : " + err.statusText;
      if (this.moduleid == 0) {
        const abridgeddetails = await this.classmanager
          .getClassDetailsAbridged(classid)
          .toPromise();
        this.moduleid = abridgeddetails.moduleid;
      }
      this.route.navigate(['/user/moduledetails'], {
        queryParams: { moduleID: this.moduleid },
      });

      this.fetchingdata = false;
    }
  }

  popconfirmdelete(show: number) {
    $('#deleteLesson').modal('show');
  }

  popconfirmdeletenote(show: number) {
    $('#deleteLessonnote').modal('show');
  }

  gotoUpcomingEvents() {
    this.route.navigate(['/events/view'], {
      queryParams: { moduleID: this.moduleid, isStudent: 1,classid:this.classid }
    });
  }

  async deleteLesson() {
    $('#deleteLesson').modal('hide');
    await this.classmanager
      .deleteclass(this.classid, this.moduleid)
      .toPromise();
    this.route.navigate(['/user/moduledetails'], {
      queryParams: { moduleID: this.moduleid },
    });
    this.toastr.success('Successfully deleted');
  }

  async deleteLessonnote() {
    $('#deleteLessonnote').modal('hide');
    this.lessonnote.forEach(async l => await this.classmanager
      .deleteclassnote(this.classid, l.id)
      .toPromise() )
    
    //this.route.navigate(['/user/moduledetails'], { queryParams: { moduleID: this.moduleid } });
    this.toastr.success('Lesson Note Successfully Deleted');
    // this.route.navigate(['/user/lesson'], { queryParams: {moduleid: this.moduleid , classid:this.classid} });
    window.location.reload();
  }

  async saveclassfile(files: FileList) {
    this.showlessonfileupload = false;
    this.classFileName = '';

    let totalfilesize = 0;
    for (let i = 0; i < files.length; i++) {
      totalfilesize += files[0].size;
    }

    this.classfiles = await this.classmanager
            .saveclassfile(this.moduleid, this.classid, files)
            .toPromise();
          this.toastr.success('File Uploaded Successfully');

    // this.modulemanager
    //   .getMediaStatus(this.lesson.schoolid, totalfilesize)
    //   .toPromise()
    //   .then(async (response: boolean) => {
    //     if (response) {
    //       this.classfiles = await this.classmanager
    //         .saveclassfile(this.moduleid, this.classid, files)
    //         .toPromise();
    //       this.toastr.success('File Uploaded Successfully');
    //     } else {
    //       this.toastr.error(
    //         'Upload Failed. You Have Exceeded Your Media Storage Limit'
    //       );
    //     }
    //   });
  }
  delete(o: any, a: any) {
    //debugger;
  }

  async deleteclassfile(fileid: any) {
    this.classfiles = await this.classmanager
      .deleteclassfile(this.classid, fileid)
      .toPromise();
    this.toastr.success('File Deleted Successfully');
  }
  togglelessonfileupload(show: number) {
    if (show == 1) {
      this.showlessonfileupload = true;
    } else {
      this.showlessonfileupload = false;
    }
  }

  async nextclicked() {
    //debugger;
    if (
      !this.lesson.adminuser &&
      this.lesson.moduleRequiresLessonCompletion &&
      !this.isClassCompleted
    ) {
      this.toastr.error(
        'Please Complete this lesson before proceeding',
        'Please Complete Lesson'
      );
    } else {
      this.route.navigate(['/user/lesson'], {
        queryParams: { classid: this.nextlesson.id, moduleid: this.moduleid },
      });
    }
  }

  async deleteliveclassschedule(scheduleid: number) {
    // this.headerinfo.pageLoadingStarted(this);

    await this.classmanager.deleteliveclassschedule(scheduleid).toPromise();
    this.liveclassschedules = this.liveclassschedules.filter(
      (x) => x.id != scheduleid
    );
    // await this.classmanager.getLiveClassSchedules(this.classid).toPromise().then((data) => this.liveclassschedules = data).finally(() => this.headerinfo.pageLoadingDone(this));

    this.toastr.success('Schedule Deleted Successfully');
  }

  markCompletedclicked() {
    if (!this.isClassCompleted) {
      this.headerinfo.pageLoadingStarted(this);

      this.classmanager
        .markLessonCompleted(this.classid)
        .toPromise()
        .then(async (res: any) => {
          this.toastr.success('Lesson completed.');
          this.isClassCompleted = true;
          if (res.lastLesson) {
            this.route.navigate(['/user/moduledetails'], {
              queryParams: { moduleID: this.moduleid },
            });
            if (res.allClassesCompleted) {
              this.toastr.success(
                'You\'ve completed all the lessons. Use the "Complete Course" button below to complete the course',
                'Congratulations!!!'
              );
            }
          }
          this.headerinfo.pageLoadingDone(this);
        })
        .catch(() => this.headerinfo.pageLoadingDone(this));
    }
  }
  isExpierd(item: any) {
    if (new Date(item.inviteEndDate) > new Date()) {
      return false;
    }
    return true;
  }
  getStatus(item:any){
    if (new Date(item.inviteStartDate) < new Date() && new Date(item.inviteEndDate) > new Date()){
      return "Ongoing";
    }
    return "Upcoming"
  }

  canJoinEvents(evet:SchoolModuleEvent){
    let isLink =this.util.isLink(evet.venue);
    let today = new Date();
    let startEvent = new Date(evet.inviteStartDate);
    startEvent.setMinutes(startEvent.getMinutes() - 5);//reomving 5min from startTime to show join btn early.
    let endEvent = new Date(evet.inviteEndDate);
    if(startEvent <= today && endEvent > today && isLink){
      return true;
    }
    return false;
  }
  joinEvent(url){
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = "_blank"
    anchor.click();
  }

  async nextPage(){
    if (this.currentPage < this.lessonnote.length){
      this.currentPage = this.currentPage + 1;
      this.loadNotes(this.currentPage);  
    }   
    else if (this.lessonnote.length == this.currentPage && this.enableNextLesson) {
      this.nextclicked();
    } 
  }
  async previousPage(){
    if(this.currentPage == 1 && this.prevlesson ){
      this.route.navigate(['/user/lesson'], {queryParams: { classid: this.prevlesson.id, moduleid:this.moduleid} })
    }
    else{
      this.currentPage = this.currentPage - 1;
      this.loadNotes(this.currentPage);
    }
  }
  async gotoPage(page: number){
    this.loadNotes(page);
  }
}
